import { Link as MuiLink } from '@mui/material';
import { Box } from '@mui/system';
import { Link, type LinkOptions } from '@tanstack/react-router';
import useCollapseDrawer from 'hooks/useCollapseDrawer';
import type { FC, ReactNode, Ref } from 'react';
import { ListItemStyle } from './style';

type Props = {
  activeRoot?: boolean;
  activeSub?: boolean;
  children: ReactNode;
  subItem?: boolean;
  ref?: Ref<HTMLAnchorElement>;
} & (
  | (LinkOptions & { href?: never })
  | { href: string; target?: string; rel?: string; onClick?: () => void }
);

const ListItemLink: FC<Props> = ({ activeRoot, activeSub, children, subItem, ...other }) => {
  const { isCollapse } = useCollapseDrawer();
  const sx = isCollapse && !subItem ? { px: 0 } : undefined;

  if (other.href) {
    return (
      <MuiLink sx={{ textDecoration: 'none !important' }} {...other}>
        {/* biome-ignore lint/a11y/useValidAriaRole: ListItem would set the 'button' role, which makes no sense in an 'anchor'*/}
        <ListItemStyle role={undefined} sx={sx} {...{ activeRoot, activeSub, subItem }}>
          {children}
        </ListItemStyle>
      </MuiLink>
    );
  }

  return (
    // We can't use <ListItemStyle component={Link} /> directly because it strips out the search prop
    <Box component={Link} sx={{ textDecoration: 'none' }} {...other}>
      {/* biome-ignore lint/a11y/useValidAriaRole: ListItem would set the 'button' role, which makes no sense in an 'anchor'*/}
      <ListItemStyle role={undefined} sx={sx} {...{ activeRoot, activeSub, subItem }}>
        {children}
      </ListItemStyle>
    </Box>
  );
};

export default ListItemLink;
